var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVarchatIconRobot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1823_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.256 0H26.744C11.9737 0 0 11.9737 0 26.744V213.256C0 228.026 11.9737 240 26.744 240H213.256C228.026 240 240 228.026 240 213.256V26.744C240 11.9737 228.026 0 213.256 0Z",
    fill: "#344D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4001 167.536H164.592C191.448 167.536 213.256 189.344 213.256 216.2V240H26.7441V216.2C26.7441 189.344 48.5521 167.536 75.4081 167.536H75.4001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.912 181.176C107.816 182.064 113.856 182.536 120 182.536C126.144 182.536 132.192 182.072 138.088 181.176V153.016H101.912V181.176Z",
    fill: "#EFA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 61.992C122.328 61.992 124.216 60.104 124.224 57.776V18.528C124.224 16.2 122.336 14.312 120 14.312C117.672 14.312 115.784 16.2 115.784 18.528V57.776C115.784 60.104 117.672 61.992 120 61.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32 56.408H97.6802V65.016H142.32V56.408Z",
    fill: "#5ABEBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.032 26.688C124.344 26.688 127.84 23.1922 127.84 18.88C127.84 14.5678 124.344 11.072 120.032 11.072C115.72 11.072 112.224 14.5678 112.224 18.88C112.224 23.1922 115.72 26.688 120.032 26.688Z",
    fill: "#EFA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.984 101.032H196.992V116.824H213.984V101.032Z",
    fill: "#EFA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0081 101.032H26.0161V116.824H43.0081V101.032Z",
    fill: "#EFA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.432 108.928C205.432 133.272 184.72 153.008 159.16 153.008H80.7759C55.2239 153.008 34.5039 133.272 34.5039 108.928C34.5039 84.584 55.2159 64.848 80.7759 64.848H159.16C184.712 64.848 205.432 84.584 205.432 108.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7764 132.048C66.8244 132.048 55.4644 121.68 55.4644 108.928C55.4644 96.176 66.8164 85.808 80.7764 85.808H159.16C173.112 85.808 184.472 96.176 184.472 108.928C184.472 121.68 173.12 132.048 159.16 132.048H80.7764Z",
    fill: "#E1E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6642 132.12C91.4728 132.12 101.856 121.737 101.856 108.928C101.856 96.1194 91.4728 85.736 78.6642 85.736C65.8556 85.736 55.4722 96.1194 55.4722 108.928C55.4722 121.737 65.8556 132.12 78.6642 132.12Z",
    fill: "#5ABEBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28 132.12C174.088 132.12 184.472 121.737 184.472 108.928C184.472 96.1194 174.088 85.736 161.28 85.736C148.471 85.736 138.088 96.1194 138.088 108.928C138.088 121.737 148.471 132.12 161.28 132.12Z",
    fill: "#5ABEBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28 114.352C164.276 114.352 166.704 111.924 166.704 108.928C166.704 105.932 164.276 103.504 161.28 103.504C158.284 103.504 155.856 105.932 155.856 108.928C155.856 111.924 158.284 114.352 161.28 114.352Z",
    fill: "#344D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6642 114.352C81.6598 114.352 84.0882 111.924 84.0882 108.928C84.0882 105.932 81.6598 103.504 78.6642 103.504C75.6686 103.504 73.2402 105.932 73.2402 108.928C73.2402 111.924 75.6686 114.352 78.6642 114.352Z",
    fill: "#344D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.088 108.928H101.856",
    stroke: "#344D66",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 153.008V228.928",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.856 167.536H138.088V185.656C138.088 195.656 129.968 203.776 119.968 203.776C109.968 203.776 101.848 195.656 101.848 185.656V167.536H101.856Z",
    fill: "#5ABEBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 167.536V240",
    stroke: "#344D66",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.744 2.5H213.256C226.646 2.5 237.5 13.3544 237.5 26.744V213.256C237.5 226.646 226.646 237.5 213.256 237.5H26.744C13.3544 237.5 2.5 226.646 2.5 213.256V26.744C2.5 13.3544 13.3544 2.5 26.744 2.5Z",
    stroke: "#344D66",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1823_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarchatIconRobot2);
export default __webpack_public_path__ + "static/media/varchat-icon-robot-2.3fc881eeae43221f1925bf1cf5fdc418.svg";
export { ForwardRef as ReactComponent };